module.exports = __webpack_public_path__ + "static/media/article2.50fd588f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/articles/article2.jpeg
// module id = 91
// module chunks = 0